<template>
    <div id="roleMain">
        <div class="button-bar">
            <el-select
                v-model="roleId"
                reserve-keyword
                placeholder="请选择角色"
                size="small"
                @change="changeRole"
                v-if="isRole"
            >
                <el-option
                    v-for="item in users"
                    :key="item.val"
                    :label="item.name"
                    :value="item.val"
                ></el-option>
            </el-select>

            <el-button type="primary" size="small" @click="saveChecked">保存</el-button>
        </div>
        <div>
            <el-tree
                :data="menus"
                show-checkbox
                default-expand-all
                node-key="id"
                :props="props"
                :default-checked-keys="checked"
                ref="menutree"
                @check="checkeTree"
                check-strictly
            ></el-tree>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isRole: { type: Boolean, default: true },
        userId: { type: Number, default: null },
        afterAdd: { type: Function, default: null },
    },
    data() {
        return {
            roleId: null,
            users: [
                { id: "0", name: "管理员", val: "AD" },
                { id: "1", name: "要员", val: "IU" },
                { id: "1000", name: "员工", val: "US" },
                { id: "2000", name: "工厂用户", val: "FC" },
                { id: "3000", name: "B端用户", val: "TB" },
                { id: "3001", name: "B端业务员", val: "BB" },
                { id: "3002", name: "B端管理员", val: "BM" },
                { id: "4000", name: "C端用户", val: "TC" },
                { id: "4001", name: "C端业务员", val: "CB" },
                { id: "4002", name: "C端管理员", val: "CM" },
            ],
            props: {
                label: "name",
                children: "sub",
            },
            menus: null,
            checked: null,
        };
    },
    methods: {
        allmenus() {
            let _this = this;

            _this.$http.post(
                ["/menu/all"],
                [
                    function (data) {
                        _this.menus = data;
                    },
                ],
                "#roleMain"
            );
        },
        saveChecked() {
            let _this = this;
            let ids = _this.$refs.menutree.getCheckedKeys().join(",");

            if (!_this.roleId) {
                _this.$message({
                    message: "请先选择角色",
                    type: "error",
                });
                return;
            }

            _this.$http.post(
                ["menu/role/save", { roleId: _this.roleId, menusIds: ids }],
                [
                    function (data, message) {
                        _this.$emit("afterAdd", data);
                        message("保存成功");
                    },
                ],
                "#roleMain"
            );
        },
        changeRole(val) {
            let _this = this;

            _this.$http.post(
                ["menu/role/get", { roleId: val }],
                [
                    function (data) {
                        _this.roleId = val;

                        let keys = [];

                        if (data) {
                            keys = data.split(",");
                        }

                        _this.$refs.menutree.setCheckedKeys(keys);
                    },
                ],
                "#roleMain"
            );
        },
        checkeTree(data) {
            let thisNode = this.$refs.menutree.getNode(data.id); // 获取当前节点
            const keys = this.$refs.menutree.getCheckedKeys(); // 获取已勾选节点的key值

            if (thisNode.checked) {
                // 当前节点若被选中
                for (let i = thisNode.level; i > 1; i--) {
                    // 判断是否有父级节点
                    if (!thisNode.parent.checked) {
                        // 父级节点未被选中，则将父节点替换成当前节点，往上继续查询，并将此节点key存入keys数组
                        thisNode = thisNode.parent;
                        keys.push(thisNode.data.id);
                    }
                }
            }

            this.$refs.menutree.setCheckedKeys(keys); // 将所有keys数组的节点全选中
        },
    },
    mounted() {
        this.allmenus();

        if (this.userId) {
            this.changeRole(this.userId);
        }
    },
    watch: {
        userId(val) {
            this.changeRole(val);
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
